export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/touchpoint-info.28c3ab2b-4db12b.png";